import React, { useState } from "react";
import "./GalleryFull.css";

const galleryImages = [
  { src: "/assets/gallery/slide1.webp" },
  { src: "/assets/gallery/slide2.webp" },
  { src: "/assets/gallery/slide3.webp" },
  { src: "/assets/gallery/img1.webp" },
  { src: "/assets/gallery/img2.webp" },
  { src: "/assets/gallery/img3.webp" },
  { src: "/assets/gallery/img4.webp" },
    { src: "/assets/gallery/IMG_20220326_011927_913.webp" },

  { src: "/assets/gallery/img5.webp" },
  { src: "/assets/gallery/img6.webp" },
  { src: "/assets/gallery/img7.webp" },
  { src: "/assets/gallery/img8.webp" },
    { src: "/assets/gallery/IMG_7623.webp" },
  { src: "/assets/gallery/IMG_7631.webp" },

  { src: "/assets/services/ssmodular-operation-theaters.webp" },
  { src: "/assets/services/Modular-NICU-PICU.webp" },
  { src: "/assets/services/ivf.webp" },
  { src: "/assets/services/cathlab.webp" },
  { src: "/assets/services/ot-door.webp" },
  { src: "/assets/services/laminar-air-flow.webp" },
  { src: "/assets/services/air-sterilizer.webp" },
  { src: "/assets/services/antibacterial-stretch.webp" },
  { src: "/assets/services/turnkey-project-for-clean-room.webp" },
  { src: "/assets/services/surgical-scrub-sink.webp" },
  { src: "/assets/services/passbox.webp" },
  { src: "/assets/services/Vinyl-Flooring.webp" },
  { src: "/assets/services/ot_pendant.webp" },
  { src: "/assets/services/hosp_ducting.jpg" },
  { src: "/assets/services/hosp_ahu.webp" },
  { src: "/assets/services/surgeon-control-panel.webp" },
  { src: "/assets/services/epoxy-work.webp" },
];

const GalleryFull = () => {
  const [activeImage, setActiveImage] = useState(null);

  return (
    <div className="gallery-fp-page">
      <h1 className="fp-title">Our Gallery</h1>

      {/* GRID */}
      <div className="fp-grid">
        {galleryImages.map((img, index) => (
          <div
            key={index}
            className="fp-item"
            onClick={() => setActiveImage(img)}
          >
            <div className="fp-image-wrapper">
              <img src={img.src} alt="" loading="lazy" />
            </div>
          </div>
        ))}
      </div>

      {/* MODAL */}
      {activeImage && (
        <div className="fp-modal-overlay" onClick={() => setActiveImage(null)}>
          <div className="fp-image-modal" onClick={(e) => e.stopPropagation()}>
            <button
              className="fp-modal-close"
              onClick={() => setActiveImage(null)}
            >
              ×
            </button>

            <img src={activeImage.src} alt="" className="fp-modal-image" />
          </div>
        </div>
      )}
    </div>
  );
};

export default GalleryFull;
